import { AfterViewInit, Component, Input, OnInit, signal } from '@angular/core';
import { Countries } from 'src/app/model/countries';
import { ProfilDetails } from 'src/app/model/profilDetails';
import { AuthService } from 'src/app/modules/auth/services/auth.service';
import {
  AbstractControl,
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { Days } from 'src/app/model/days';
import { Mounths } from 'src/app/model/mounths';
import { Years } from 'src/app/model/years';
import { LOCALISATIONS } from 'src/app/model/localisations';
import { Candidature } from 'src/app/model/candidature';
import { ActivatedRoute, Router } from '@angular/router';
import { BackendApiService } from 'src/app/service/backend-api.service';
import {
  Observable,
  catchError,
  forkJoin,
  map,
  of,
  switchMap,
  tap,
} from 'rxjs';
import {
  CandidatureRequest,
  PrerequisiteDTO,
} from 'src/app/model/CandidatureRequest.model';
import { confirmEqualValidator } from 'src/app/modules/shared/validators/confirm-equal';
import { SpinnerServiceService } from 'src/app/modules/shared/serviceSpinner/spinner-service.service';
@Component({
  selector: 'app-form-appel-one-family',
  templateUrl: './form-appel-one-family.component.html',
  styleUrls: ['./form-appel-one-family.component.css'],
})
export class FormAppelOneFamilyComponent implements OnInit {
  [x: string]: any;
  prerequisites: PrerequisiteDTO[] = [];
  genericPrerequisites: any[] = [];
  genList: any[] = [];
  countries!: Countries[];
  phoneCode!: any[];
  phoneCodeWhatsapp!: any[];

  soumissionForm!: FormGroup;
  emailForm!: FormGroup;

  appelName!: string;
  appelCloseDate!: string;
  appelOpenDate!: string;

  days!: any;
  months!: any;
  years!: any;
  diplomes!: any;
  students!: any;
  otherStatus!: any;
  zones!: any;
  regions!: any;
  user!: any;
  applicationId: any; //je fixe l'applicationId en attendant de le recuperer dans le path
  indexPrerequities!: number;
  listCriteria: any[] = [];
  baremes: any[] = [];
  availibility: any[] = [];
  series: any[] = [];

  disciplines: any[] = [];

  skillLevel!: any;
  prerequisiteIndexTable: string[] = [];
  prerequisiteGenIndexTable: string[] = [];
  isSucces: boolean = false;
  allFieldNotSelected: boolean = false;
  isNotANumber: boolean = false;
  isOlder: boolean = false;
  emailMatched: boolean = false;
  typedEmail: string = '';
  showSpecificRegionDiv: boolean = false;
  showZoneDiv: boolean = true;
  showHandicapChoiceRadio: boolean = false;
  chooseAHandicapMoteur: boolean = true;
  chooseAHandicapAuditif: boolean = true;
  chooseAHandicapVisuel: boolean = true;
  chooseAHandicapAutre: boolean = true;
  pageOne: boolean = true;
  pageTwo: boolean = false;
  pageThree: boolean = false;
  showDegreeDiv: boolean = false;
  showStudentDiv: boolean = false;
  showOtherSituationDiv: boolean = false;
  showSeriesDiv: boolean = false;
  showDisciplineDivBTS: boolean = false;
  showDisciplineDivLicence: boolean = false;
  showDisciplineDivM1: boolean = false;
  showDisciplineDivM2: boolean = false;
  showDisciplineDivDoctorat: boolean = false;

  //Variable for validity check
  familyChoiceChecked: boolean | undefined;
  pageTwoValid: boolean | undefined;
  pageOneValid: boolean = false;
  checkPageOneFields: boolean = true;

  checkPageTwoFields: boolean = true;
  fillPageTwoFields: boolean = false;
  fillPageOneFields: boolean = false;
  showWhatsAppNumberFields: boolean = false;

  controlsList: string[] = [
    'firstname',
    'lastname',
    'selectedDate',
    'selectedSexe',
    'phoneNumber',
    'phoneNumberWave',
    'phoneCode',
    'isWhatsApp',
    'emailGroup.email',
    'emailGroup.confirmEmail',
    'selectedCountry',
    'selectedSituation',
    'selectedRegion',
    'selectedZone',
    'inHandicapSituation',
    'professionnalSituation',
  ];

  //Initialize handicap valueCheks

  handicap_Visuel: boolean = false;
  handicap_Auditif: boolean = false;
  handicap_Moteur: boolean = false;
  handicap_Autre: boolean = false;
  applied: boolean = false;
  isMentor: boolean = false;
  previousSession: boolean = false;
  admission: boolean = false;
  session: boolean = false;
  noSession: boolean = false;

  //Famille de metier et prerequis!
  families: any[] = [];

  cohorte: string = '';
  previousCohorte: string[] = [
    'SIG2408-FODE',
    'SIG2412-FODE',
    'SIG2502-FODE',
    'SIG2505-FODE',
    'SIG2508-FODE',
    'SIG2509-FODE',
    'SIG2510-FODE',
    'SIG2511-FODE',
  ];

  showEmailErrors$!: Observable<boolean>;

  showSpinner = false;

  constructor(
    private formBuilder: FormBuilder,
    private service: BackendApiService,
    private backendapiService: AuthService,
    private spinnerService: SpinnerServiceService,
    private router: Router
  ) {
    this.spinnerService.spinner$.subscribe((data: boolean) => {
      setTimeout(() => {
        this.showSpinner = data ? data : false;
      });
    });

    this.emailForm = this.formBuilder.group(
      {
        email: [null, [Validators.required, Validators.email]],
        confirmEmail: [null, [Validators.required, Validators.email]],
      },
      {
        validators: [confirmEqualValidator('email', 'confirmEmail')],
      }
    );
    this.soumissionForm = this.formBuilder.group({
      firstname: [null, Validators.required],
      lastname: [null, Validators.required],
      selectedDate: [null, Validators.required],
      selectedSexe: [null, Validators.required],
      phoneNumber: [null, Validators.required],
      phoneNumberWave: [null, Validators.required],
      phoneCode: ['221', Validators.required],
      isWhatsApp: [null, Validators.required],
      whatsAppNumber: [null],
      phoneCodeForWhatsApp: ['221'],
      emailGroup: this.emailForm,
      selectedCountry: [null, Validators.required],
      selectedDiplome: [null],
      selectedSerie: [null],
      selectedDisciplineForBTS: [null],
      selectedDisciplineForLicence: [null],
      selectedDisciplineForM1: [null],
      selectedDisciplineForM2: [null],
      selectedDisciplineForDoctorat: [null],
      professionnalSituation: [null, Validators.required],
      selectedStudyLevel: [null],
      selectedOtherStatus: [null],
      selectedSituation: [null, Validators.required],
      selectedRegion: [null, Validators.required],
      selectedZone: [null, Validators.required],
      specifyRegion: [null],
      inHandicapSituation: [null, Validators.required],

      //page two
      familyChoice: [null, Validators.required],
      //page three
      availability: [null, Validators.required],
      mediaSupport: [null, Validators.required],
      conditions: [null, Validators.requiredTrue],
      yourProject: [null, Validators.required],
      isCertified: [null, Validators.required],
    });
  }

  ngOnInit(): void {
    this.spinnerService.showSpinner();

    this.soumissionForm
      .get('isWhatsApp')
      ?.valueChanges.subscribe((isWhatsApp) => {
        if (isWhatsApp === 'NON') {
          this.showWhatsAppNumberFields = true;
          this.soumissionForm
            .get('whatsAppNumber')
            ?.addValidators(Validators.required);
          this.soumissionForm
            .get('phoneCodeForWhatsApp')
            ?.addValidators(Validators.required);
        } else {
          this.showWhatsAppNumberFields = false;
          this.soumissionForm.get('whatsAppNumber')?.clearValidators();
          this.soumissionForm.get('phoneCodeForWhatsApp')?.clearValidators();
        }
      });

    this.showEmailErrors$ = this.emailForm.statusChanges.pipe(
      map(
        (status) =>
          status === 'INVALID' &&
          this.emailForm.get('email')?.value &&
          this.emailForm.get('confirmEmail')?.value
      )
    );

    this.backendapiService.getCountries().subscribe((data) => {
      this.countries = data.sort((c, d) => (c.name < d.name ? -1 : 1));
    });
    this.backendapiService.getCountries().subscribe((data) => {
      // //console.log(data);

      this.phoneCode = data.sort((c, d) => c.phoneCode - d.phoneCode);
      //console.log(this.phoneCode);

      this.phoneCodeWhatsapp = this.phoneCode;
    });

    this.controlsList.forEach((value) => {
      //console.log('element', value);
    });

    this.soumissionForm
      .get('selectedCountry')
      ?.valueChanges.subscribe((values) => {
        if (values === 'Autre') {
          this.soumissionForm.addControl(
            'otherCountry',
            this.formBuilder.control(null, Validators.required)
          );
          this.controlsList.push('otherCountry');
        } else {
          this.soumissionForm.removeControl('otherCountry');
          this.controlsList = this.controlsList.filter(
            (e) => e !== 'otherCountry'
          );
        }
      });

    this.showHandicapChoices();
    this.showDivForActuelStatus();
    this.setHandicapCheckValues('handicaps_visuel', this.handicap_Visuel);
    this.setHandicapCheckValues('handicaps_auditif', this.handicap_Auditif);
    this.setHandicapCheckValues('handicaps_moteur', this.handicap_Moteur);
    this.setHandicapCheckValues('handicaps_autre', this.handicap_Autre);

    //Optionnal divs
    this.showDivForSeries();
    this.showDivForDisciplinesOfBTS();
    this.showDivForDisciplinesOfLicence();
    this.showDivForDisciplinesOfM1();
    this.showDivForDisciplinesOfM2();

    this.showDivForDisciplinesOfDoctorat();

    /*****************************/

    this.service
      .getCurrentApplication()
      .pipe(
        tap((application) => {
          // console.log(application);
          this.spinnerService.hideSpinner();
          if (application.status == 200 && application.object.length > 0) {
            this.session = true;
            this.noSession = false;
            //console.log(application);
            this.appelName = application.object[0].applicationName;
            this.genericPrerequisites =
              application.object[0].genericPrerequisiteList;

            this.cohorte = application.object[0].cohorte;
            this.appelCloseDate = application.object[0].closeDate;
            this.families = application.object[0].familyMetierDTOList;
            // console.log('l"application : ', this.families[0]);

            this.initialisePrerequisities(this.families[0]);

            // console.log('l"application : ', application.object[0]);
          } else {
            this.session = false;
            this.noSession = true;
          }
        })
      )
      .subscribe();

    // this.initialisePrerequisities();

    this.isEmailMatched();

    this.zones = LOCALISATIONS.Zones;
    this.regions = LOCALISATIONS.Regions;

    this.diplomes = ProfilDetails.DiplomeForApplications;
    this.students = ProfilDetails.Student;
    this.otherStatus = ProfilDetails.OtherStatus;

    this.days = Days.List;
    this.months = Mounths.List;
    this.years = Years.List;

    this.baremes = ProfilDetails.Bareme;
    this.availibility = ProfilDetails.Availability;

    this.series = ProfilDetails.Series;
    this.disciplines = ProfilDetails.Discipline;
  }

  onSubmitForm() {
    const formValue = this.soumissionForm.value;
    const MailFormValue = this.emailForm.value;

    if (this.soumissionForm.invalid) {
      //console.log('formvalue["conditions"');
      this.markInvalidField('conditions');
      this.markInvalidField('yourProject');
      this.markInvalidField('isCertified');
      this.markInvalidField('mediaSupport');
      this.markInvalidField('availability');

      this.allFieldNotSelected = true;
      setTimeout(() => {
        this.allFieldNotSelected = false;
      }, 2500);
    } else {
      window.scrollTo(0, 0);
      this.spinnerService.showSpinner();
      const formValue = this.soumissionForm.value;

      //Renseignement du champ whatsappNumber

      let whatsappNumber = '';

      if (formValue['isWhatsApp'] === 'OUI') {
        whatsappNumber = formValue['phoneCode'] + formValue['phoneNumber'];
      } else if (formValue['isWhatsApp'] === 'NON') {
        whatsappNumber =
          formValue['phoneCodeForWhatsApp'] + formValue['whatsAppNumber'];
      } else {
        whatsappNumber = '';
      }

      //Renseignement du champ phoneNumber

      const myNumber = formValue['phoneCode'] + formValue['phoneNumber'];

      //Renseignement du champ nationality et du champ right_nationality

      let right_nationality = '';

      if (formValue['selectedCountry'] === 'Autre') {
        right_nationality = formValue['otherCountry'];
      } else {
        right_nationality = '';
      }

      // Renseignement des champ en rapport avec professionnalSituation

      let level = '';
      let high_diploma = '';
      let right_status = '';
      let entrepfre = '';

      if (formValue['professionnalSituation'] === 'Etudiant') {
        level = formValue['selectedStudyLevel'];
      } else {
        level = '';
      }

      if (formValue['professionnalSituation'] === 'Diplômé/Sans emploi') {
        high_diploma = formValue['selectedDiplome'];
      } else {
        high_diploma = '';
      }

      if (
        formValue['professionnalSituation'] ===
        'Autre ( Salarié, non-diplômé, auto-emploi...)'
      ) {
        right_status = formValue['selectedOtherStatus'];
      } else {
        right_status = '';
      }

      if (formValue['professionnalSituation'] === 'Entrepreneur ou freelance') {
        entrepfre = 'Entrepreneur ou freelance';
      } else {
        entrepfre = '';
      }

      //Renseignement du champ pour right_region

      let right_region = '';

      if (formValue['selectedRegion'] === 'Hors Sénégal') {
        right_region = formValue['specifyRegion'];
      } else {
        right_region = '';
      }

      //Renseignement du champ pour handicap_moteur, handicap_visuel, handicap_auditif, handicap_autre

      let handicap_moteur = '';
      let handicap_visuel = '';
      let handicap_auditif = '';
      let handicap_autre = '';

      if (formValue['inHandicapSituation'] === 'Oui') {
        if (formValue['handicaps_visuel']) {
          handicap_visuel = 'Malvoyant';
        } else {
          handicap_visuel = '';
        }

        if (formValue['handicaps_auditif']) {
          handicap_auditif = 'Malentendant';
        } else {
          handicap_auditif = '';
        }

        if (formValue['handicaps_moteur']) {
          handicap_moteur = 'Handicap moteur';
        } else {
          handicap_moteur = '';
        }

        if (formValue['handicaps_autre']) {
          handicap_autre = 'Autre handicap';
        } else {
          handicap_autre = '';
        }
      }

      //Renseignement du champ family_num

      let family_num: any;
      this.families.forEach((family) => {
        if (family.name === formValue['familyChoice']) {
          family_num = family.id;
        }
      });

      //Renseignement du champ mark

      let mark: number = 0;

      let prerequisiteTab = this.prerequisiteIndexTable.slice();

      prerequisiteTab.forEach((controlName) => {
        mark = mark + +this.soumissionForm.get(controlName)?.value;
      });

      //Renseignement du champ prerequisiteList

      // Dupliquer le tableau
      let prerequisiteResponse: PrerequisiteDTO[] = JSON.parse(
        JSON.stringify(this.prerequisites)
      );

      let genericPrerequisiteResponse: PrerequisiteDTO[] = JSON.parse(
        JSON.stringify(this.genericPrerequisites)
      );

      //console.log('Tableau dupliquer generic: ', genericPrerequisiteResponse);
      //console.log('Tableau dupliquer: ', prerequisiteResponse);

      // genericPrerequisiteResponse.forEach((genericPrerequisite, index) => {
      //   genericPrerequisite.markPrereq = +this.soumissionForm.get(
      //     'selectedgenPrerequisite_' + index
      //   )?.value;
      // });

      prerequisiteResponse.forEach((prerequisite, index) => {
        prerequisite.markPrereq = +this.soumissionForm.get(
          'selectedPrerequisite_' + index
        )?.value;
      });

      //console.log('Prerequisite liste: ', prerequisiteResponse);
      //console.log('Generic Prerequisite liste: ', genericPrerequisiteResponse);

      //Renseignement des champs sur les filieres et series
      let bac = '';
      let bts = '';
      let licenceOrMaster = '';
      let doctorat = '';

      if (formValue['selectedDiplome'] === 'Baccalauréat') {
        bac = formValue['selectedSerie'];
      } else {
        bac = '';
      }

      if (formValue['selectedDiplome'] === 'BTS/DUT/DEUG') {
        bts = formValue['selectedDisciplineForBTS'];
      } else {
        bts = '';
      }

      if (formValue['selectedDiplome'] === 'Licence (Bac+3)') {
        licenceOrMaster = formValue['selectedDisciplineForLicence'];
      } else if (formValue['selectedDiplome'] === 'Master 1') {
        licenceOrMaster = formValue['selectedDisciplineForM1'];
      } else if (formValue['selectedDiplome'] === 'Master 2') {
        licenceOrMaster = formValue['selectedDisciplineForM2'];
      } else {
        licenceOrMaster = '';
      }

      if (formValue['selectedDiplome'] === 'Doctorat') {
        doctorat = formValue['selectedDisciplineForDoctorat'];
      } else {
        doctorat = '';
      }

      const candidatureRequest = new CandidatureRequest(
        new Date(),
        formValue['conditions'],
        formValue['firstname'],
        formValue['lastname'],
        new Date(formValue['selectedDate']),
        this.Age(formValue['selectedDate']),
        formValue['selectedSexe'],
        myNumber,
        formValue['isWhatsApp'],
        whatsappNumber,
        formValue['phoneNumberWave'],
        MailFormValue['email'],
        formValue['selectedCountry'],
        right_nationality,
        formValue['professionnalSituation'],
        level,
        right_status,
        high_diploma,
        bac,
        bts,
        licenceOrMaster,
        doctorat,
        formValue['selectedRegion'],
        right_region,
        formValue['selectedZone'],
        formValue['inHandicapSituation'],
        '',
        handicap_moteur,
        handicap_visuel,
        handicap_auditif,
        handicap_autre,
        formValue['selectedSituation'],
        formValue['familyChoice'],
        family_num,
        '',
        formValue['mediaSupport'],
        formValue['isCertified'],
        mark,
        '',
        '',
        formValue['availability'],
        formValue['yourProject'],
        this.cohorte,
        false,
        false,
        prerequisiteResponse,
        formValue['selectedgenPrerequisite_0'],
        formValue['selectedgenPrerequisite_1'],
        formValue['selectedgenPrerequisite_2'],
        formValue['selectedgenPrerequisite_3'],
        formValue['selectedgenPrerequisite_4'],
        formValue['selectedgenPrerequisite_5'],
        formValue['selectedgenPrerequisite_6'],
        formValue['selectedgenPrerequisite_7'],
        formValue['selectedgenPrerequisite_8'],
        formValue['selectedgenPrerequisite_9'],
        formValue['selectedgenPrerequisite_10'],
        formValue['selectedgenPrerequisite_11'],
        formValue['selectedgenPrerequisite_12'],
        formValue['selectedgenPrerequisite_13']
      );

      this.service
        .apply(candidatureRequest)
        .pipe(
          tap((response) => {
            if (response != null) {
              this.spinnerService.hideSpinner();
              this.isSucces = true;
              sessionStorage.setItem('canSuccess', '1');

              setTimeout(() => {
                this.soumissionForm.reset();
                this.isSucces = false;

                this.router.navigateByUrl('sigui/candidature/SIG2509/reussie');
              }, 2500);
            }
          })
        )
        .subscribe();
      // console.log('candidature : ', candidatureRequest);
    }
  }

  addControls(arrayOfPrerequisite: any[]) {
    this.prerequisiteIndexTable = [];

    arrayOfPrerequisite.forEach((prerequisite, index) => {
      const controlName = 'selectedPrerequisite_' + index;

      this.soumissionForm.addControl(
        controlName,
        this.formBuilder.control(null, Validators.required) // Ajout de la validation requise
      );

      this.prerequisiteIndexTable.push('selectedPrerequisite_' + index);
    });
  }
  addControls2(arrayOfPrerequisite: any[]) {
    this.prerequisiteGenIndexTable = [];

    arrayOfPrerequisite.forEach((prerequisite, index) => {
      const controlName = 'selectedgenPrerequisite_' + index;

      this.soumissionForm.addControl(
        controlName,
        this.formBuilder.control(null, Validators.required) // Ajout de la validation requise
      );

      this.prerequisiteGenIndexTable.push('selectedgenPrerequisite_' + index);
    });
  }
  getSelectedCriteria(formSoumission: FormGroup): any {
    for (let index = 0; index < this.indexPrerequities; index++) {
      const element = 'selectedPrerequisite_' + index;

      this.listCriteria.push(formSoumission.get(element)?.value);
    }
    return this.listCriteria;
  }

  markInvalidField(controlName: string) {
    const control = this.soumissionForm.get(controlName);

    if (control && control.invalid) {
      control.markAsTouched();
    }
  }

  isFieldInvalid(controlName: string): boolean | null {
    const control = this.soumissionForm.get(controlName);

    return control && control.invalid && control.touched;
  }

  isFieldInvalidForMails(controlName: string): boolean | null {
    const control = this.soumissionForm.get(controlName);

    return control && control.errors?.['required'] && control.touched;
  }

  isMailFieldInvalid(control: string): boolean | null {
    return (
      this.emailForm.get(control)?.errors?.['email'] &&
      this.emailForm.get(control)?.touched
    );
  }

  Age(dateOfBirth: string): number {
    const today = new Date();
    const birthDate = new Date(dateOfBirth);
    let age = today.getFullYear() - birthDate.getFullYear();

    const monthDifference = today.getMonth() - birthDate.getMonth();

    // Si le mois courant est avant le mois de naissance ou si c'est le même mois mais que le jour courant est avant le jour de naissance, décrémente l'âge
    if (
      monthDifference < 0 ||
      (monthDifference === 0 && today.getDate() < birthDate.getDate())
    ) {
      age--;
    }

    return age;
  }

  isEmailMatched() {
    this.soumissionForm
      .get('email')
      ?.valueChanges.pipe(
        tap((email) => {
          if (email != null && email != undefined) {
            //console.log('mail check: ', email != null && email != undefined);

            if (this.soumissionForm.get('confirmEmail')?.value === email) {
              this.emailMatched = true;
            } else {
              this.emailMatched = false;
            }
          }
        })
      )
      .subscribe();
  }

  showSpecifyDiv() {
    this.soumissionForm
      .get('selectedRegion')
      ?.valueChanges.subscribe((region) => {
        if (region == 15) {
          this.showSpecificRegionDiv = true;
          this.soumissionForm.removeControl('selectedZone');
        } else {
          this.showSpecificRegionDiv = false;
        }
      });

    return this.showSpecificRegionDiv;
  }

  showZoneOfResidenceDiv() {
    if (this.showSpecificRegionDiv) {
      this.showZoneDiv = false;
    } else {
      this.showZoneDiv = true;
      this.soumissionForm.addControl(
        'selectedZone',
        this.formBuilder.control(null, Validators.required)
      );
    }
    return this.showZoneDiv;
  }

  get handicaps(): FormArray {
    return this.soumissionForm.get('handicaps') as FormArray;
  }

  showHandicapChoices(): void {
    this.soumissionForm
      .get('inHandicapSituation')
      ?.valueChanges.subscribe((inHandicapSituation) => {
        if (inHandicapSituation === 'Oui') {
          this.showHandicapChoiceRadio = true;

          this.addHandicapsArray();
          this.handicapCheck();
        } else {
          this.showHandicapChoiceRadio = false;
          this.removeHandicapsArray();
        }
      });
  }

  handicapCheck(): void {
    this.soumissionForm
      .get('handicaps_moteur')
      ?.valueChanges.subscribe((moteur) => {
        //console.log('moteur: ', moteur);
        if (moteur === true) {
          //console.log('moteur: ', moteur);
          this.chooseAHandicapMoteur = false;
        } else {
          this.chooseAHandicapMoteur = true;
        }
      });
    this.soumissionForm
      .get('handicaps_visuel')
      ?.valueChanges.subscribe((visuel) => {
        if (visuel === true) {
          this.chooseAHandicapVisuel = false;
        } else {
          this.chooseAHandicapVisuel = true;
        }
      });
    this.soumissionForm
      .get('handicaps_auditif')
      ?.valueChanges.subscribe((auditif) => {
        if (auditif === true) {
          this.chooseAHandicapAuditif = false;
        } else {
          this.chooseAHandicapAuditif = true;
        }
      });
    this.soumissionForm
      .get('handicaps_autre')
      ?.valueChanges.subscribe((autre) => {
        if (autre === true) {
          this.chooseAHandicapAutre = false;
        } else {
          this.chooseAHandicapAutre = true;
        }
      });
  }

  addHandicapsArray(): void {
    this.soumissionForm.addControl(
      'handicaps_moteur',
      this.formBuilder.control(false) // Ajout de la validation requise
    );
    this.soumissionForm.addControl(
      'handicaps_visuel',
      this.formBuilder.control(false) // Ajout de la validation requise
    );
    this.soumissionForm.addControl(
      'handicaps_auditif',
      this.formBuilder.control(false) // Ajout de la validation requise
    );
    this.soumissionForm.addControl(
      'handicaps_autre',
      this.formBuilder.control(false) // Ajout de la validation requise
    );
  }

  removeHandicapsArray(): void {
    this.soumissionForm.removeControl('handicaps_visuel');
    this.soumissionForm.removeControl('handicaps_moteur');
    this.soumissionForm.removeControl('handicaps_auditif');
    this.soumissionForm.removeControl('handicaps_autre');
  }

  // switchOnPageTwo() {
  //   // Check Admission
  //   //Pour que les controle ne soit pas rajouter plusieurs fois!
  //   console.log(
  //     'my services : ',
  //     this.service.checkIsMentor(this.emailForm.get('email')?.value)
  //   );
  //   this.service
  //     .checkIsMentor(this.emailForm.get('email')?.value)
  //     .pipe(
  //       tap((value) => {
  //         console.log('valoooo :', value);
  //         if (value) {
  //           console.log("L'utilisateur est un mentor !");
  //         } else {
  //           console.log("L'utilisateur n'est PAS un mentor.");
  //         }
  //       })
  //     )
  //     .subscribe();

  //   this.service
  //     .applyCheckOneFamily(
  //       this.emailForm.get('email')?.value,
  //       this.cohorte,
  //       this.previousCohorte
  //     )
  //     .pipe(
  //       tap((response) => {
  //         // console.log('deja dans la cohorte: ', response);
  //         if (
  //           response.admited ||
  //           response.applied ||
  //           response.previousCohorte
  //         ) {
  //           this.session = false;

  //           if (response.applied) {
  //             this.applied = true;
  //             setTimeout(() => {
  //               this.applied = false;
  //               window.location.reload();
  //             }, 3000);
  //           } else if (response.previousCohorte) {
  //             this.previousSession = true;
  //             setTimeout(() => {
  //               this.previousSession = false;
  //               window.location.reload();
  //             }, 3000);
  //           } else if (response.admited) {
  //             this.admission = true;
  //             setTimeout(() => {
  //               this.admission = false;
  //               window.location.reload();
  //             }, 3000);
  //           }
  //         } else {
  //           this.applied = false;

  //           let List = this.controlsList.slice();
  //           this.checkPageOneValidity(List);

  //           if (this.pageOneValid) {
  //             this.pageOne = false;
  //             this.pageTwo = true;
  //             this.pageThree = false;

  //             setTimeout(() => {
  //               this.scrollToSection('page-two'), window.scrollTo(0, 0);
  //             }, 0);
  //           }
  //         }
  //       })
  //     )
  //     .subscribe();
  // }

  switchOnPageTwo() {
    const email = this.emailForm.get('email')?.value?.toLowerCase();
    // console.log('recup email :', email);

    this.service
      .checkIsMentor(email)
      .pipe(
        catchError((error) => {
          console.error('Erreur API (checkIsMentor) :', error);
          return of(false);
        }),
        switchMap((isMentor) => {
          // console.log('Utilisateur mentor ?', isMentor);

          if (isMentor) {
            this.isMentor = true;
            this.session = false;

            setTimeout(() => {
              this.isMentor = false;
              window.location.reload();
            }, 3500);

            // console.log("L'utilisateur est un mentor !");
            return of(null);
          } else {
            this.isMentor = false;
            // console.log("L'utilisateur n'est PAS un mentor.");

            // Si ce n'est PAS un mentor, on exécute `applyCheckOneFamily`
            return this.service
              .applyCheckOneFamily(email, this.cohorte, this.previousCohorte)
              .pipe(
                catchError((error) => {
                  console.error('Erreur API (applyCheckOneFamily) :', error);
                  return of({
                    applied: false,
                    admited: false,
                    previousCohorte: false,
                  });
                })
              );
          }
        })
      )
      .subscribe((response) => {
        if (!response) {
          // console.log(
          //   "Aucune vérification supplémentaire car l'utilisateur est un mentor."
          // );
          return;
        }

        if (response.admited || response.applied || response.previousCohorte) {
          this.session = false;

          if (response.applied) {
            this.applied = true;
          } else if (response.previousCohorte) {
            this.previousSession = true;
          } else if (response.admited) {
            this.admission = true;
          }

          setTimeout(() => {
            this.applied = false;
            this.previousSession = false;
            this.admission = false;
            window.location.reload();
          }, 3000);
        } else {
          this.applied = false;
          let List = this.controlsList.slice();
          this.checkPageOneValidity(List);

          if (this.pageOneValid) {
            this.pageOne = false;
            this.pageTwo = true;
            this.pageThree = false;

            setTimeout(() => {
              this.scrollToSection('page-two'), window.scrollTo(0, 0);
            }, 0);
          }
        }
      });
  }

  switchOnPageThree() {
    this.checkPageTwoValidity(
      this.prerequisiteIndexTable,
      this.prerequisiteGenIndexTable
    );

    if (this.pageTwoValid == true) {
      this.pageOne = false;
      this.pageTwo = false;
      this.pageThree = true;

      setTimeout(() => {
        this.scrollToSection('page-three'), window.scrollTo(0, 0);
      }, 0);
    }
  }
  goBackOnPageOne() {
    this.pageOne = true;
    this.pageTwo = false;
    this.pageThree = false;

    setTimeout(() => {
      this.scrollToSection('page-one'), window.scrollTo(0, 0);
    }, 0);
  }

  scrollToSection(sectionId: string) {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  showDivForActuelStatus() {
    this.soumissionForm
      .get('professionnalSituation')
      ?.valueChanges.subscribe((status) => {
        if (status == 'Diplômé/Sans emploi') {
          this.showDegreeDiv = true;
          this.showStudentDiv = false;
          this.showOtherSituationDiv = false;

          this.setValidators(
            'selectedDiplome',
            'selectedStudyLevel',
            'selectedOtherStatus'
          );
        } else if (status == 'Etudiant') {
          this.showStudentDiv = true;
          this.showDegreeDiv = false;
          this.showOtherSituationDiv = false;

          this.setValidators(
            'selectedStudyLevel',
            'selectedDiplome',
            'selectedOtherStatus'
          );
        } else if (status == 'Autre ( Salarié, non-diplômé, auto-emploi...)') {
          this.showOtherSituationDiv = true;
          this.showStudentDiv = false;
          this.showDegreeDiv = false;

          this.setValidators(
            'selectedOtherStatus',
            'selectedDiplome',
            'selectedStudyLevel'
          );
        } else if (status == 'Entrepreneur ou freelance') {
          this.showOtherSituationDiv = false;
          this.showStudentDiv = false;
          this.showDegreeDiv = false;

          this.setValidators(
            'selectedOtherStatus',
            'selectedDiplome',
            'selectedStudyLevel'
          );
        }
      });

    return this.showSpecificRegionDiv;
  }

  showDivForSeries() {
    this.soumissionForm
      .get('selectedDiplome')
      ?.valueChanges.subscribe((value) => {
        if (value === 'Baccalauréat') {
          this.showSeriesDiv = true;

          this.soumissionForm
            .get('selectedSerie')
            ?.addValidators(Validators.required);
        } else {
          this.showSeriesDiv = false;
          this.soumissionForm.get('selectedSerie')?.setValue(null);
          this.soumissionForm
            .get('selectedSerie')
            ?.removeValidators(Validators.required);
        }
      });
  }

  showDivForDisciplinesOfBTS() {
    this.soumissionForm
      .get('selectedDiplome')
      ?.valueChanges.subscribe((value) => {
        if (value === 'BTS/DUT/DEUG') {
          this.showDisciplineDivBTS = true;

          this.soumissionForm
            .get('selectedDisciplineForBTS')
            ?.addValidators(Validators.required);
        } else {
          this.showDisciplineDivBTS = false;
          this.soumissionForm.get('selectedDisciplineForBTS')?.setValue(null);
          this.soumissionForm
            .get('selectedDisciplineForBTS')
            ?.removeValidators(Validators.required);
        }
      });
  }

  showDivForDisciplinesOfLicence() {
    this.soumissionForm
      .get('selectedDiplome')
      ?.valueChanges.subscribe((value) => {
        if (value === 'Licence (Bac+3)') {
          this.showDisciplineDivLicence = true;

          this.soumissionForm
            .get('selectedDisciplineForLicence')
            ?.addValidators(Validators.required);
        } else {
          this.showDisciplineDivLicence = false;
          this.soumissionForm
            .get('selectedDisciplineForLicence')
            ?.setValue(null);
          this.soumissionForm
            .get('selectedDisciplineForLicence')
            ?.removeValidators(Validators.required);
        }
      });
  }

  showDivForDisciplinesOfM1() {
    this.soumissionForm
      .get('selectedDiplome')
      ?.valueChanges.subscribe((value) => {
        if (value === 'Master 1') {
          this.showDisciplineDivM1 = true;

          this.soumissionForm
            .get('selectedDisciplineForM1')
            ?.addValidators(Validators.required);
        } else {
          this.showDisciplineDivM1 = false;
          this.soumissionForm.get('selectedDisciplineForM1')?.setValue(null);
          this.soumissionForm
            .get('selectedDisciplineForM1')
            ?.removeValidators(Validators.required);
        }
      });
  }

  showDivForDisciplinesOfM2() {
    this.soumissionForm
      .get('selectedDiplome')
      ?.valueChanges.subscribe((value) => {
        if (value === 'Master 2') {
          this.showDisciplineDivM2 = true;

          this.soumissionForm
            .get('selectedDisciplineForM2')
            ?.addValidators(Validators.required);
        } else {
          this.showDisciplineDivM2 = false;
          this.soumissionForm.get('selectedDisciplineForM2')?.setValue(null);
          this.soumissionForm
            .get('selectedDisciplineForM2')
            ?.removeValidators(Validators.required);
        }
      });
  }

  showDivForDisciplinesOfDoctorat() {
    this.soumissionForm
      .get('selectedDiplome')
      ?.valueChanges.subscribe((value) => {
        if (value === 'Doctorat') {
          this.showDisciplineDivDoctorat = true;

          this.soumissionForm
            .get('selectedDisciplineForDoctorat')
            ?.addValidators(Validators.required);
        } else {
          this.showDisciplineDivDoctorat = false;
          this.soumissionForm
            .get('selectedDisciplineForDoctorat')
            ?.setValue(null);
          this.soumissionForm
            .get('selectedDisciplineForDoctorat')
            ?.removeValidators(Validators.required);
        }
      });
  }

  setValidators(
    controlToAdd: string,
    controlToRemove: string,
    controToRemove2: string
  ) {
    this.soumissionForm.get(controlToAdd)?.addValidators(Validators.required);
    this.soumissionForm
      .get(controlToRemove)
      ?.removeValidators(Validators.required);
    this.soumissionForm
      .get(controToRemove2)
      ?.removeValidators(Validators.required);

    this.soumissionForm.get(controlToRemove)?.setValue(null);
    this.soumissionForm.get(controToRemove2)?.setValue(null);
  }
  //Ancien
  checkPageTwoValidity(
    prerequisitesControls: string[],
    genericPrerequisiteControls: string[]
  ) {
    if (this.soumissionForm.get('familyChoice')?.invalid) {
      this.checkPageTwoFields = this.checkPageTwoFields && false;
    }

    prerequisitesControls.forEach((control) => {
      if (this.soumissionForm.get(control)?.invalid) {
        this.checkPageTwoFields = this.checkPageTwoFields && false;
      }
    });

    genericPrerequisiteControls.forEach((control) => {
      if (this.soumissionForm.get(control)?.invalid) {
        this.checkPageTwoFields = this.checkPageTwoFields && false;
      }
    });

    //Marquage en rouge des champs non remplis
    if (this.checkPageTwoFields === false) {
      this.markInvalidField('familyChoice');

      prerequisitesControls.forEach((control) => {
        this.markInvalidField(control);
      });

      genericPrerequisiteControls.forEach((control) => {
        this.markInvalidField(control);
      });
    }

    this.pageTwoValid = this.checkPageTwoFields;

    if (this.pageTwoValid == false) {
      this.fillPageTwoFields = true;

      setTimeout(() => {
        this.fillPageTwoFields = false;
      }, 2500);
    }

    this.checkPageTwoFields = true;
  }
  //Ancien
  // checkPageOneValidity(controls: string[]) {
  //   if (
  //     this.soumissionForm.get('professionnalSituation')?.value != null &&
  //     this.soumissionForm.get('professionnalSituation')?.value != undefined
  //   ) {
  //     if (
  //       this.soumissionForm.get('professionnalSituation')?.value ===
  //       'Diplômé/Sans emploi'
  //     ) {
  //       controls.push('selectedDiplome');
  //     } else if (
  //       this.soumissionForm.get('professionnalSituation')?.value === 'Etudiant'
  //     ) {
  //       controls.push('selectedStudyLevel');
  //     } else if (
  //       this.soumissionForm.get('professionnalSituation')?.value ===
  //       'Autre ( Salarié, non-diplômé, auto-emploi...)'
  //     ) {
  //       controls.push('selectedOtherStatus');
  //     }
  //   }

  //   if (this.showSeriesDiv) {
  //     controls.push('selectedSerie');
  //   }
  //   if (this.showDisciplineDivBTS) {
  //     controls.push('selectedDisciplineForBTS');
  //   }
  //   if (this.showDisciplineDivLicence) {
  //     controls.push('selectedDisciplineForLicence');
  //   }
  //   if (this.showDisciplineDivM1) {
  //     controls.push('selectedDisciplineForM1');
  //   }
  //   if (this.showDisciplineDivM2) {
  //     controls.push('selectedDisciplineForM2');
  //   }
  //   if (this.showDisciplineDivDoctorat) {
  //     controls.push('selectedDisciplineForDoctorat');
  //   }

  //   if (this.showWhatsAppNumberFields) {
  //     controls.push('whatsAppNumber');
  //     controls.push('phoneCodeForWhatsApp');
  //   }
  //   /*********************************************************************/

  //   controls.forEach((control) => {
  //     //console.log(control, ': ', this.soumissionForm.get(control)?.valid);
  //     if (this.soumissionForm.get(control)?.invalid) {
  //       this.checkPageOneFields = false;
  //     }
  //   });

  //   if (
  //     this.soumissionForm.get('inHandicapSituation')?.value === 'Oui' &&
  //     (this.soumissionForm.get('handicaps_visuel')?.value === true ||
  //       this.soumissionForm.get('handicaps_moteur')?.value === true ||
  //       this.soumissionForm.get('handicaps_auditif')?.value === true ||
  //       this.soumissionForm.get('handicaps_autre')?.value === true)
  //   ) {
  //     this.checkPageOneFields = this.checkPageOneFields && true;
  //   } else if (
  //     this.soumissionForm.get('inHandicapSituation')?.value === 'Non'
  //   ) {
  //     this.checkPageOneFields = this.checkPageOneFields && true;
  //   } else {
  //     this.checkPageOneFields = this.checkPageOneFields && false;
  //   }
  //   //Marquage en rouge des champs non remplis

  //   if (this.checkPageOneFields === false) {
  //     controls.forEach((control) => {
  //       this.markInvalidField(control);
  //     });
  //   }

  //   this.pageOneValid = this.checkPageOneFields;

  //   if (!this.pageOneValid) {
  //     this.fillPageOneFields = true;

  //     setTimeout(() => {
  //       this.fillPageOneFields = false;
  //     }, 2500);
  //   }
  //   this.checkPageOneFields = true;
  // }
  //Nouveau
  checkPageOneValidity(controls: string[]) {
    const situation = this.soumissionForm.get('professionnalSituation')?.value;
    this.soumissionForm.get('selectedDiplome')?.clearValidators();
    this.soumissionForm.get('selectedStudyLevel')?.clearValidators();
    this.soumissionForm.get('selectedOtherStatus')?.clearValidators();

    if (situation) {
      if (situation === 'Diplômé/Sans emploi') {
        controls.push('selectedDiplome');
        this.soumissionForm
          .get('selectedDiplome')
          ?.setValidators([Validators.required]);
      } else if (situation === 'Etudiant') {
        controls.push('selectedStudyLevel');
        this.soumissionForm
          .get('selectedStudyLevel')
          ?.setValidators([Validators.required]);
      } else if (
        situation === 'Autre ( Salarié, non-diplômé, auto-emploi...)'
      ) {
        controls.push('selectedOtherStatus');
        this.soumissionForm
          .get('selectedOtherStatus')
          ?.setValidators([Validators.required]);
      }
    }

    this.soumissionForm.get('selectedDiplome')?.updateValueAndValidity();
    this.soumissionForm.get('selectedStudyLevel')?.updateValueAndValidity();
    this.soumissionForm.get('selectedOtherStatus')?.updateValueAndValidity();

    if (this.showSeriesDiv) {
      controls.push('selectedSerie');
    }
    if (this.showDisciplineDivBTS) {
      controls.push('selectedDisciplineForBTS');
    }
    if (this.showDisciplineDivLicence) {
      controls.push('selectedDisciplineForLicence');
    }
    if (this.showDisciplineDivM1) {
      controls.push('selectedDisciplineForM1');
    }
    if (this.showDisciplineDivM2) {
      controls.push('selectedDisciplineForM2');
    }
    if (this.showDisciplineDivDoctorat) {
      controls.push('selectedDisciplineForDoctorat');
    }

    if (this.showWhatsAppNumberFields) {
      controls.push('whatsAppNumber');
      controls.push('phoneCodeForWhatsApp');
    }

    controls.forEach((control) => {
      if (this.soumissionForm.get(control)?.invalid) {
        this.checkPageOneFields = false;
      }
    });

    if (
      this.soumissionForm.get('inHandicapSituation')?.value === 'Oui' &&
      (this.soumissionForm.get('handicaps_visuel')?.value === true ||
        this.soumissionForm.get('handicaps_moteur')?.value === true ||
        this.soumissionForm.get('handicaps_auditif')?.value === true ||
        this.soumissionForm.get('handicaps_autre')?.value === true)
    ) {
      this.checkPageOneFields = this.checkPageOneFields && true;
    } else if (
      this.soumissionForm.get('inHandicapSituation')?.value === 'Non'
    ) {
      this.checkPageOneFields = this.checkPageOneFields && true;
    } else {
      this.checkPageOneFields = this.checkPageOneFields && false;
    }

    if (this.checkPageOneFields === false) {
      controls.forEach((control) => {
        this.markInvalidField(control);
      });
    }

    this.pageOneValid = this.checkPageOneFields;

    if (!this.pageOneValid) {
      this.fillPageOneFields = true;
      setTimeout(() => {
        this.fillPageOneFields = false;
      }, 2500);
    }

    this.checkPageOneFields = true;
  }

  setHandicapCheckValues(control: string, controlCheck: boolean) {
    this.soumissionForm.get(control)?.valueChanges.subscribe((value) => {
      if (value != null || value != undefined) {
        controlCheck = true;
      }
    });
  }

  // initialisePrerequisitie() {
  //   this.soumissionForm
  //     .get('familyChoice')
  //     ?.valueChanges.pipe(
  //       tap((family) => {
  //         this.genList = this.genericPrerequisites;
  //         this.addControls2(this.genList);
  //         const object = this.families.find((data) => {
  //           //console.log("Verification de l'objet:", data);
  //           return data.name === family;
  //         });

  //         if (object) {
  //           this.prerequisites = [];
  //           this.prerequisites = object.prerequisite.filter(
  //             (prerequisite: any) => {
  //               return prerequisite.markPrereq === 0;
  //             }
  //           );

  //           this.addControls(this.prerequisites);
  //         } else {
  //         }
  //       })
  //     )
  //     .subscribe();
  // }

  initialisePrerequisities(family: any) {
    //on selectionne l famille
    const singleFamilly = family;
    // console.log('single familly : ', singleFamilly.name);

    if (singleFamilly) {
      this.genList = this.genericPrerequisites;
      this.addControls2(this.genList);

      // Filtrer les prérequis pour cette famille unique
      this.prerequisites = singleFamilly.prerequisite.filter(
        (prerequisite: any) => prerequisite.markPrereq === 0
      );

      // Ajouter les contrôles liés aux prérequis
      this.addControls(this.prerequisites);

      // Initialiser la valeur de "familyChoice" dans le formulaire
      this.soumissionForm.get('familyChoice')?.setValue(singleFamilly.name);
    }
  }
}
